const generateInputField = ({
  id: fieldId,
  fieldType,
  name,
  label,
  value: givenValue,
  defaultValue,
  placeholder,
  options,
  isDisabled = true,
  columnClass = 'sub-section-content-column',
  withClearBtn = false,
}) => {
  const column = document.createElement('div')
  column.className = `${columnClass} ehv-element`
  column.id = name
  column.style.minWidth = '25rem'

  let inputHtml = ''
  let value = givenValue || defaultValue || undefined
  const isExternalApprovalLimit = fieldType === 'CurrencyInput' &&
    (name === 'property_max_capex' || name === 'proprety_max_capex')

  if (fieldType === 'TextInput') {
    inputHtml = `
      <input
        class="ant-input Input impowerx-text-input ${isDisabled ? 'ant-input-disabled' : ''}"
        placeholder="${placeholder || ''}"
        type="text"
        value="${value || ''}"
        name="${name}"
        data-field-id="${fieldId}"
        ${isDisabled ? 'disabled' : ''}
      />
    `
  } else if (fieldType === 'DateInput' || fieldType === 'DatePicker') {
    // Mount point for lux-picker (unified inject date picker); filled after innerHTML below.
    inputHtml = `<div class="lux-picker-mount"></div>`
    column.classList.add(fieldType)
  } else if (fieldType === 'CurrencyInput') {
    // An explicitly cleared external limit must not restore a catalog default.
    const currencyValue = isExternalApprovalLimit ? (givenValue ?? defaultValue ?? '') : (value || defaultValue || '')
    const currencyPlaceholder = isExternalApprovalLimit ? 'Keine Freigabegrenze extern' : (placeholder || '')
    inputHtml = `
        <span class="ant-input-affix-wrapper ${isDisabled ? 'ant-input-affix-wrapper-disabled' : ''} ant-input-affix-wrapper-readonly Input">
          <input ${isDisabled ? 'readonly' : ''} class="ant-input ${isDisabled ? 'ant-input-disabled' : ''} impowerx-currency-input" inputmode="decimal" ${isDisabled ? 'disabled' : ''} type="text" value="${currencyValue}" name="${name}" data-field-id="${fieldId}" placeholder="${currencyPlaceholder}" />
          <span class="ant-input-suffix">€</span>
        </span>
      `
  } else if (fieldType === 'PercentageInput' || fieldType === 'NumberInput') {
    const isPercentage = fieldType === 'PercentageInput'
    const inputClass = isPercentage ? 'impowerx-percentage-input' : 'impowerx-number-input'
    const defaultPlaceholder = isPercentage ? '0,00' : '0'

    if (value && !isNaN(Number(value))) {
      const displayValue = isPercentage ? Number(value) * 100 : Number(value)
      value = formatGermanNumber(String(displayValue).replace('.', ','), true, true)
    }

    const suffix = isPercentage
      ? `<span class="suffix ${isDisabled ? '' : 'suffix-with-controls'}" ${isDisabled ? 'style="color: rgba(0, 0, 0, 0.25);"' : ''}>%</span>`
      : ''

    inputHtml = `
        <div class="ant-input-number InputNumber Input ${isDisabled ? 'ant-input-number-disabled' : ''}" style="${isDisabled ? 'border-color: transparent;' : ''}">
          <div class="ant-input-number-handler-wrap" style="${isDisabled ? 'display: none !important; width: 0; overflow: hidden;' : ''}">
            <span unselectable="on" role="button" aria-label="Increase Value" aria-disabled="false" class="ant-input-number-handler ant-input-number-handler-up">
              <span role="img" class="anticon">
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M5 0H3V3H0V5H3V8H5V5H8V3H5V0Z" fill="black"></path>
                </svg>
              </span>
            </span>
            <span unselectable="on" role="button" aria-label="Decrease Value" aria-disabled="false" class="ant-input-number-handler ant-input-number-handler-down">
              <span role="img" class="anticon">
                <svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <rect x="8" width="2" height="8" transform="rotate(90 8 0)" fill="black"></rect>
                </svg>
              </span>
            </span>
          </div>
          <div class="ant-input-number-input-wrap">
            <input autocomplete="off" role="spinbutton" style="text-align: right; background: transparent; padding-right: ${isDisabled ? '11px' : '24px'};${isDisabled ? ' color: rgba(0, 0, 0, 0.25);' : ''}" class="ant-input-number-input ${inputClass} ${isDisabled ? 'ant-input-disabled' : ''}" ${isDisabled ? 'disabled' : ''} value="${value || ''}" name="${name}" data-field-id="${fieldId}" placeholder="${placeholder || defaultPlaceholder}" />
            ${suffix}
          </div>
        </div>
      `
  } else if (fieldType === 'RadioGroup') {
    inputHtml = `
        <div class="ant-radio-group ant-radio-group-outline RadioGroup SwitchElement justify-content-unset" name="${name}" data-field-id="${fieldId}">
          ${options
        .map(
          (option) => `<div class="radio-group-option">
                <label class="ant-radio-wrapper ${isDisabled ? 'ant-radio-wrapper-disabled' : ''} ant-radio-wrapper-in-form-item">
                  <span class="ant-radio ${isDisabled ? 'ant-radio-disabled' : ''} ${value === option.value ? 'ant-radio-checked' : ''}">
                    <input type="radio" ${isDisabled ? 'disabled' : ''} class="ant-radio-input" value="${option.value}" onclick="toggleRadioCheck(this)">
                    <span class="ant-radio-inner"></span>
                  </span>
                  <span>${option.label}</span>
                </label>
              </div>`
        )
        .join('')}
        </div>
      `
    column.classList.add('RadioGroupInput')
  } else if (fieldType === 'CheckboxGroup') {
    const checkedOptions = value ? value.split('|') : []

    inputHtml = `
      <div class="ant-checkbox-group" name="${name}" data-field-id="${fieldId}">
        ${options
        .map(
          (option) => `<label class="ant-checkbox-wrapper ${isDisabled ? 'ant-checkbox-wrapper-disabled' : ''} ant-checkbox-wrapper-in-form-item ant-checkbox-group-item">
          <span class="ant-checkbox ${isDisabled ? 'ant-checkbox-disabled' : ''} ${checkedOptions.includes(option.value) ? 'ant-checkbox-checked' : ''}">
            <input type="checkbox" ${isDisabled ? 'disabled' : ''} class="ant-checkbox-input" value="${option.value}" ${checkedOptions.includes(option.value) ? 'checked' : ''} onclick="handleCheckboxClick(this)" />
            <span class="ant-checkbox-inner"></span>
          </span>
          <span style="font-size: 16px;">${option.label}</span>
        </label>`
        )
        .join('')}
      </div>
    `

    column.classList.add('CheckboxGroupInput')
    column.style.height = 'unset'
  } else if (fieldType === 'DropdownMenu') {
    inputHtml = `
      <div class="ant-select ant-select-in-form-item Select ant-select-single ant-select-show-arrow ant-select-show-search ${isDisabled ? 'read-only ant-select-disabled' : ''} impowerx-select" disabled="${isDisabled}" name="${name}" data-field-id="${fieldId}" style="position: relative; overflow: visible;">
        <div class="ant-select-selector">
          <span class="ant-select-selection-search">
            <input type="search" ${isDisabled ? 'disabled' : ''} autocomplete="off" class="ant-select-selection-search-input" role="combobox" aria-haspopup="listbox" aria-owns="rc_select_0_list" aria-autocomplete="list" aria-controls="rc_select_0_list" aria-activedescendant="rc_select_0_list_0" value="" id="rc_select_0" aria-expanded="false" placeholder="${!value ? (placeholder || '') : ''}">
          </span>
          <span class="ant-select-selection-item" title="${value || ''}">${value || ''}</span>
        </div>

        <span class="ant-select-arrow" unselectable="on" aria-hidden="true" style="user-select: none;">
          <span role="img" class="anticon">
            <svg width="10" height="5" viewBox="0 0 10 5" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L5 5L10 0H0Z" fill="#000000"></path>
            </svg>
          </span>
        </span>
      </div>

      <div style="position: absolute; top: 0px; left: 0px; width: 100%;" class="dropdown-wrapper">
        <div>
          <div class="ant-select-dropdown ant-select-dropdown-placement-bottomRight ant-select-dropdown-hidden impowerx-select-dropdown"
            style="z-index: 2000; width: 100%; left: 0px; top: 45px;">
            <div>
              <div role="listbox" id="rc_select_3_list" style="height: 0px; width: 0px; overflow: hidden;">
                <div role="option" id="rc_select_3_list_2" aria-selected="false">C</div>
                <div role="option" id="rc_select_3_list_3" aria-selected="false">D</div>
              </div>
              <div class="rc-virtual-list" style="position: relative;">
                <div class="rc-virtual-list-holder" style="max-height: 256px; overflow-y: hidden; overflow-anchor: none;">
                  <div>
                    <div class="rc-virtual-list-holder-inner" style="display: flex; flex-direction: column;">
                      ${options
        .map(
          (
            option
          ) => `<div aria-selected="true" class="ant-select-item ant-select-item-option ant-select-item-option-selected impowerx-select-menu-item" title="${option.label}">
                        <div class="ant-select-item-option-content">
                          <div class="select-menu-item">${option.label}</div>
                        </div>
                      </div>`
        )
        .join('')}
                    </div>
                  </div>
                </div>
                <div class="rc-virtual-list-scrollbar"
                  style="width: 8px; top: 0px; bottom: 0px; right: 0px; position: absolute; display: none;">
                  <div class="rc-virtual-list-scrollbar-thumb"
                    style="width: 100%; height: 128px; top: 0px; left: 0px; position: absolute; background: rgba(0, 0, 0, 0.5); border-radius: 99px; cursor: pointer; user-select: none;">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `

    column.classList.add('Select')
  } else if (fieldType === 'ContactComboBox') {
    const rawContactId =
      givenValue != null && givenValue !== '' ? String(givenValue).trim() : ''
    const contactId =
      rawContactId &&
      rawContactId !== '""' &&
      rawContactId !== "''" &&
      /^\d+$/.test(rawContactId) &&
      parseInt(rawContactId, 10) > 0
        ? rawContactId
        : ''
    value = contactId || undefined
    const selectedContactOption = (options || []).find((opt) => String(opt.value) === String(value))
    const displayContactLabel = selectedContactOption
      ? selectedContactOption.label
      : contactId
        ? `Kontakte-${contactId}`
        : ''
    const allowClearClass = withClearBtn ? ' ant-select-allow-clear' : ''
    const clearInsideSelectHtml = withClearBtn
      ? `
          <span class="ant-select-clear impowerx-contact-combobox-clear" unselectable="on" style="user-select: none; display: none; position: absolute; right: 11px; top: 50%; transform: translateY(-50%); z-index: 2; width: 12px; height: 12px; margin-top: 0; line-height: 1; color: rgba(0,0,0,0.25); font-size: 12px; align-items: center; justify-content: center;">
            <button type="button" class="impowerx-contact-combobox-clear-btn" tabindex="-1" aria-label="Auswahl entfernen" style="border:none;background:transparent;padding:0;margin:0;cursor:pointer;line-height:1;display:inline-flex;align-items:center;color:inherit;">
              <span role="img" aria-label="close-circle" class="anticon anticon-close-circle">
                <svg viewBox="64 64 896 896" focusable="false" data-icon="close-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path></svg>
              </span>
            </button>
          </span>`
      : ''

    inputHtml = `
      <div class="contact-combobox" style="position: relative;">
        <div class="ant-select ant-select-in-form-item ContactComboBox ContactComboDisable Select ant-select-single ant-select-show-arrow ant-select-show-search${allowClearClass} ${isDisabled ? 'read-only ant-select-disabled' : ''} impowerx-select" disabled="${isDisabled}" name="${name}" data-field-id="${fieldId}" data-selected-value="${contactId}" style="position: relative;" onclick="(function(root,ev){ if(root.classList.contains('ant-select-disabled')||root.classList.contains('read-only')||root.getAttribute('disabled')==='true'){return;} var t=(ev&&(ev.target||ev.srcElement))||null; if(t&&t.closest&&t.closest('.impowerx-contact-combobox-clear,.impowerx-contact-combobox-clear-btn')){return;} var input=root.querySelector('.ant-select-selection-search-input'); var sel=root.querySelector('.ant-select-selection-item'); var prev = sel && sel.textContent ? sel.textContent.trim() : ''; if(input){ input.value=''; input.setAttribute('placeholder', prev || '${placeholder || ''}'); } if(sel){ sel.textContent=''; sel.setAttribute('title',''); } var list=(root.parentElement||root).querySelector('.contact-combobox-list'); if(list){ Array.prototype.forEach.call(list.querySelectorAll('.contact-combobox-item'), function(el){ el.style.display=''; }); } if(input && typeof input.focus==='function'){ input.focus(); } })(this,event)">
          <div class="ant-select-selector">
            <span class="ant-select-selection-search">
              <input type="search" ${isDisabled ? 'disabled' : ''} autocomplete="off" class="ant-select-selection-search-input contact-combobox-search-input" role="combobox" aria-haspopup="listbox" style="${value ? 'visibility: visible;' :'visibility: hidden;'}" aria-autocomplete="list" value="" placeholder="${!value ? (placeholder || '') : ''}" oninput="(function(i){var root=i.closest('.contact-combobox'); if(!root){return;} var list=root.querySelector('.contact-combobox-list'); if(!list){return;} var q=i.value.toLowerCase(); Array.prototype.forEach.call(list.querySelectorAll('.contact-combobox-item'), function(el){el.style.display = el.textContent.toLowerCase().indexOf(q) !== -1 ? '' : 'none';});})(this)">
            </span>
            <span class="ant-select-selection-item" title="${displayContactLabel}">${displayContactLabel}</span>
          </div>

          <span class="ant-select-arrow"  unselectable="on" aria-hidden="true" style="user-select: none;${withClearBtn ? 'display: none;' : ''}">
            <span role="img" class="anticon">
              <svg width="10" height="5" viewBox="0 0 10 5" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L5 5L10 0H0Z" fill="#000000"></path>
              </svg>
            </span>
          </span>
          ${clearInsideSelectHtml}
        </div>

        <div style="position: absolute; top: 0px; left: 0px; width: 100%;" class="dropdown-wrapper">
          <div>
            <div class="ant-select-dropdown ant-select-dropdown-placement-bottomRight ant-select-dropdown-hidden impowerx-select-dropdown"
              style="z-index: 2000; width: 100%; left: 0px; top: 45px;">
              <div class="rc-virtual-list" style="position: relative;">
                <div class="rc-virtual-list-holder" style="max-height: 256px; overflow-y: auto; overflow-anchor: none;">
                  <div>
                    <div class="rc-virtual-list-holder-inner contact-combobox-list" style="display: flex; flex-direction: column;">
                      ${options.map((option) => `
                        <div class="ant-select-item ant-select-item-option contact-combobox-item${String(option.value) === String(value) ? ' ant-select-item-option-selected' : ''}" data-value="${option.value}" title="${option.label}">
                          <div class="ant-select-item-option-content">
                            <div class="select-menu-item">${option.label}</div>
                          </div>
                        </div>`).join('')}
                    </div>
                  </div>
                </div>
                <div class="rc-virtual-list-scrollbar"
                  style="width: 8px; top: 0px; bottom: 0px; right: 0px; position: absolute; display: none;">
                  <div class="rc-virtual-list-scrollbar-thumb"
                    style="width: 100%; height: 128px; top: 0px; left: 0px; position: absolute; background: rgba(0, 0, 0, 0.5); border-radius: 99px; cursor: pointer; user-select: none;">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `

    column.classList.add('ContactComboBox')
  } else if (fieldType === 'ContactMultiSelect') {
    // value: comma or pipe separated IDs; options: { label, value }[]
    const selectedIds = value ? String(value).split(/[,|]/).map((id) => id.trim()).filter(Boolean) : []
    const selectedOptions = (options || []).filter((opt) => selectedIds.includes(String(opt.value)))
    const displayTagsHtml = selectedOptions.map((o) => `<span class="contact-multiselect-tag" title="${(o.label || '').replace(/"/g, '&quot;')}">${o.label}</span>`).join('')
    // Build options list: selected first (for when dropdown opens), then rest
    const selectedFirst = [...selectedOptions]
    const unselected = (options || []).filter((opt) => !selectedIds.includes(String(opt.value)))
    const optionsOrdered = [...selectedFirst, ...unselected]
    const hasOptions = optionsOrdered.length > 0

    inputHtml = `
      <div class="contact-multiselect-case" style="position: relative;">
        <style>
          .contact-multiselect-case .contact-multiselect-item:hover { background-color: #f5f5f5 !important; }
          .contact-multiselect-case .contact-multiselect-display { display: flex; flex-wrap: nowrap; align-items: center; gap: 4px; overflow-x: auto; overflow-y: hidden; min-height: 24px; scrollbar-width: none; -ms-overflow-style: none; }
          .contact-multiselect-case .contact-multiselect-display::-webkit-scrollbar { display: none; width: 0; height: 0; }
          .contact-multiselect-case .contact-multiselect-item .ant-select-item-option-content { min-width: 0; }
          .contact-multiselect-case .contact-multiselect-item .contact-multiselect-item-label { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1; }
          .contact-multiselect-case .contact-multiselect-item .contact-multiselect-remove { flex-shrink: 0; }
          .contact-multiselect-case .contact-multiselect-item { min-width: 0; overflow: hidden; }
          .contact-multiselect-case .contact-multiselect-tag { display: inline-flex; align-items: center; flex-shrink: 0; font-size: 12px; line-height: 20px; padding: 0 7px; background: #f5f5f5; border: 1px solid #e8e8e8; border-radius: 4px; color: rgba(0,0,0,0.85); white-space: nowrap; max-width: 100%; overflow: hidden; text-overflow: ellipsis; }
          .contact-multiselect-case .contact-multiselect-search-input { width: 100%; padding: 4px 8px; font-size: 14px; border: 1px solid #d9d9d9; border-radius: 4px; outline: none; box-sizing: border-box; }
          .contact-multiselect-case .contact-multiselect-search-input:focus { border-color: #40a9ff; box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2); }
        </style>
        <div class="ant-select ant-select-in-form-item ContactMultiSelect Select ant-select-multiple ant-select-show-arrow ant-select-show-search ${isDisabled ? 'read-only ant-select-disabled' : ''} impowerx-select impowerx-contact-multiselect" disabled="${isDisabled}" name="${name}" data-field-id="${fieldId}" data-selected-ids="${selectedIds.join(',')}" style="min-height: 40px;">
          <div class="ant-select-selector" style="min-height: 40px; height: auto; padding-right: 24px;">
            <span class="ant-select-selection-overflow" style="display: flex; flex-wrap: nowrap; align-items: center; min-width: 0; width: 100%; overflow: visible;">
              <span class="ant-select-selection-placeholder contact-multiselect-placeholder" style="visibility: ${isDisabled ? 'hidden' : 'visible'}; ${selectedOptions.length ? 'display: none;' : ''}">${placeholder || 'Bitte auswählen oder eintippen...'}</span>
              <span class="ant-select-selection-search" style="width: 0; height: 0; overflow: hidden; position: absolute;">
                <input type="search" ${isDisabled ? 'disabled' : ''} autocomplete="off" class="ant-select-selection-search-input" role="combobox" aria-autocomplete="list" placeholder="" />
              </span>
              <span class="contact-multiselect-display" style="${selectedOptions.length ? 'display: flex;' : 'display: none;'}">${displayTagsHtml}</span>
            </span>
          </div>
          <span class="ant-select-arrow" unselectable="on" aria-hidden="true" style="user-select: none;">
            <span role="img" class="anticon">
              <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L5 5L10 0H0Z" fill="#000000"></path>
              </svg>
            </span>
          </span>
        </div>
        <div style="position: absolute; top: 0; left: 0; width: 100%;" class="dropdown-wrapper">
          <div>
            <div class="ant-select-dropdown ant-select-dropdown-placement-bottomRight ant-select-dropdown-hidden impowerx-select-dropdown contact-multiselect-dropdown" style="z-index: 2000; width: 100%; left: 0; top: 40px; max-height: 280px;">
              <div class="contact-multiselect-search-wrap" style="padding: 8px; border-bottom: 1px solid #f0f0f0;">
                <input type="search" class="contact-multiselect-search-input" style="border: none;box-shadow: none;" placeholder="Suchen..." autocomplete="off" oninput="(function(i){var caseEl=i.closest('.contact-multiselect-case'); if(!caseEl){return;} var list=caseEl.querySelector('.contact-multiselect-list'); if(!list){return;} var q=(i.value||'').toLowerCase(); Array.prototype.forEach.call(list.querySelectorAll('.contact-multiselect-item'), function(el){var label=(el.getAttribute('data-label')||el.textContent||'').toLowerCase(); el.style.display=label.indexOf(q)!==-1?'':'none';}); })(this)" />
              </div>
              <div class="rc-virtual-list" style="position: relative;">
                <div class="rc-virtual-list-holder" style="max-height: 256px; overflow-y: auto; overflow-anchor: none;">
                  <div>
                    <div class="rc-virtual-list-holder-inner contact-multiselect-list" style="display: flex; flex-direction: column;">
                      ${hasOptions
                        ? optionsOrdered.map((option) => {
                        const isSelected = selectedIds.includes(String(option.value))
                        return `
                        <div class="ant-select-item ant-select-item-option contact-multiselect-item ${isSelected ? 'ant-select-item-option-selected contact-multiselect-item-selected' : ''}" data-value="${option.value}" data-label="${option.label.replace(/"/g, '&quot;')}" title="${option.label.replace(/"/g, '&quot;')}" style="${isSelected ? 'background-color: #e6f7ff;' : ''}">
                          <div class="ant-select-item-option-content" style="display: flex; align-items: center; justify-content: space-between; gap: 8px;">
                            <span class="select-menu-item contact-multiselect-item-label">${option.label}</span>
                            ${isSelected ? '<span class="contact-multiselect-remove" role="button" aria-label="Remove" style="margin-left: 8px; cursor: pointer; color: #999; font-size: 16px; line-height: 1;">×</span>' : ''}
                          </div>
                        </div>`
                      }).join('')
                        : '<div class="ant-select-item ant-select-item-option contact-multiselect-empty" style="color: rgba(0,0,0,0.45); cursor: default;"><div class="ant-select-item-option-content">Keine Kontakte vorhanden</div></div>'}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `

    column.classList.add('ContactMultiSelect')
  } else if (fieldType === 'FileInput') {
    inputHtml = fileInputHtml(fieldId, isDisabled)
  }

  column.innerHTML = `
      <div class="${fieldType}">
        <div class="ant-row ant-form-item ant-form-item-with-help" style="row-gap: 0px;">
          <div class="ant-col ant-form-item-label">
            <label title="">
              <span>${label}</span>
            </label>
          </div>
          <div class="ant-col ant-form-item-control">
            <div class="ant-form-item-control-input">
              <div class="ant-form-item-control-input-content">
                ${inputHtml}
              </div>
            </div>
            <div class="ant-form-item-explain ant-form-item-explain-connected">
              <div role="alert" class="" style=""></div>
            </div>
          </div>
        </div>
      </div>
    `

  if (isExternalApprovalLimit) {
    const input = column.querySelector('.impowerx-currency-input')
    input.setAttribute('aria-label', label)
    const defaults = typeof window !== 'undefined' ? (window.__luxPropertyApprovalDefaults || {}) : {}
    const domainValue = Number(defaults.externalAmountLimit || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    const inheritsAmount = givenValue == null || givenValue === 'inherit'
    if (inheritsAmount) {
      input.value = domainValue
      input.setAttribute('data-lux-external-limit-inherit', 'true')
    }
    input.placeholder = '0,00'
    const flag = typeof window !== 'undefined' ? window.__luxPropertyExternalApprovalEnabled : undefined
    const enabled = document.createElement('input')
    enabled.type = 'checkbox'
    enabled.className = 'lux-external-approval-enabled ant-checkbox-input'
    enabled.setAttribute('aria-label', 'Externe Rechnungsfreigabe')
    if (flag === 'inherit' || (flag == null && inheritsAmount)) {
      enabled.checked = !!defaults.externalEnabled
      enabled.setAttribute('data-lux-external-enabled-inherit', 'true')
    } else {
      enabled.checked = flag != null ? String(flag).split('|').includes('true') : Number(String(givenValue || '').replace(/\./g, '').replace(',', '.')) > 0
    }
    const toggle = document.createElement('label')
    toggle.className = 'ant-checkbox-wrapper ant-checkbox-wrapper-in-form-item'
    toggle.style.cssText = 'display:flex;align-items:center;gap:8px;margin:0 0 16px;'
    const check = document.createElement('span')
    check.className = 'ant-checkbox'
    const checkInner = document.createElement('span')
    checkInner.className = 'ant-checkbox-inner'
    check.append(enabled, checkInner)
    const title = document.createElement('span')
    title.textContent = 'Externe Rechnungsfreigabe'
    title.style.fontSize = '16px'
    toggle.append(check, title)
    column.querySelector('.CurrencyInput').prepend(toggle)
    const reset = document.createElement('button')
    reset.type = 'button'
    reset.className = 'lux-external-approval-limit-reset'
    reset.textContent = 'zurücksetzen'
    reset.setAttribute('aria-label', 'Externe Rechnungsfreigabe: zurücksetzen auf Domainstandard')
    reset.title = 'Domainstandard: ' + (defaults.externalEnabled ? domainValue + ' €' : 'deaktiviert')
    reset.style.cssText = 'display:block;align-self:flex-start;text-align:left;margin:8px auto 0 0;border:0;background:none;padding:0;color:#1b243e;text-decoration:underline;font:inherit;'
    function syncDisabled() {
      enabled.disabled = input.disabled || input.readOnly
      check.classList.toggle('ant-checkbox-checked', enabled.checked)
      check.classList.toggle('ant-checkbox-disabled', enabled.disabled)
      toggle.classList.toggle('ant-checkbox-wrapper-disabled', enabled.disabled)
      const tier = column.closest('.lux-internal-approval-tier-external')
      const body = tier && tier.querySelector('.lux-internal-approval-tier-body')
      if (body) body.style.display = enabled.checked ? 'flex' : 'none'
      const skipGroup = tier && tier.querySelector('[name="proprety_allow_skip_external_approval"]')
      reset.disabled = enabled.disabled || (input.getAttribute('data-lux-external-limit-inherit') === 'true' && enabled.getAttribute('data-lux-external-enabled-inherit') === 'true' && (!skipGroup || skipGroup.getAttribute('data-lux-external-skip-inherit') === 'true'))
      reset.style.opacity = reset.disabled ? '0.5' : '1'
      reset.style.cursor = reset.disabled ? 'default' : 'pointer'
    }
    syncDisabled()
    input.addEventListener('input', function () {
      input.removeAttribute('data-lux-external-limit-inherit')
      syncDisabled()
    })
    enabled.addEventListener('change', function () {
      enabled.removeAttribute('data-lux-external-enabled-inherit')
      syncDisabled()
    })
    enabled.addEventListener('lux-external-skip-change', syncDisabled)
    new MutationObserver(syncDisabled).observe(input, { attributes: true, attributeFilter: ['disabled', 'readonly'] })
    reset.addEventListener('click', function () {
      if (input.disabled || input.readOnly) return
      input.value = domainValue
      input.setAttribute('data-lux-external-limit-inherit', 'true')
      enabled.checked = !!defaults.externalEnabled
      enabled.setAttribute('data-lux-external-enabled-inherit', 'true')
      syncDisabled()
    })
    column.querySelector('.ant-form-item-control').appendChild(reset)
  }

  if (fieldType === 'DateInput' || fieldType === 'DatePicker') {
    const mount = column.querySelector('.lux-picker-mount')
    const picker = datePicker(name)
    // DatePicker class is required for property-page enable/save selectors.
    // Do not put DateInput on the lux-picker root — Impower may mark .DateInput as read-only.
    if (fieldType === 'DatePicker') picker.wrapper.classList.add('DatePicker')
    picker.wrapper.setAttribute('name', name)
    picker.wrapper.setAttribute('data-field-id', fieldId)
    const initial = value || defaultValue || ''
    if (initial) picker.setValue(initial)
    picker.setDisabled(!!isDisabled)
    if (mount && mount.parentNode) {
      mount.replaceWith(picker.wrapper)
    }
  }

  return column
}

const generateSubSection = (newSubSection) => {
  return `
  <div class="sub-section" id="${newSubSection}">
    <div class="sub-section-header ">
      <div class="sub-section-title">${newSubSection.replace('_', ' ')}</div>
    </div>

    <div class="sub-section-content">
      <div class="sub-section-content-row"></div>
    </div>
  </div>
  `
}

const generateSidebarLink = (newSubSection) => {
  return `
    <div class="Link sub-link impowerx-sidebar-link" id="sidebar-${newSubSection}">
      <div class="link-row level2  arrow-placeholder">
        <div class="link-title" role="button" tabindex="-1">${newSubSection.replace('_', ' ')}</div>
      </div>
    </div>
  `
}

const fileInputButtonHtml = (fileInputId = 'file-input', isDisabled = false) => {
  return `
    <button type="button" class="ant-btn ant-btn-default Button file-input-label" ${isDisabled ? 'disabled' : ''}><span role="img" class="anticon"><svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 4.41009V15.0001H10V4.41009L13.29 7.71009L14.71 6.29009L9 0.590088L3.29 6.29009L4.71 7.71009L8 4.41009ZM0 18.0001V20.0001H18V18.0001H0Z" fill="black"></path></svg></span><span>Dateien auswählen</span></button>
    <input id="${fileInputId}" ${isDisabled ? 'disabled' : ''} class="file-input impower-x-file-input" type="file" accept=".pdf,.doc,.xlsx,.jpg,.png" value="" multiple="multiple">
  `
}

const fileInputHtml = (fileInputId = 'file-input', isDisabled = false) => {
  return `
    <label style="font-weight: 500;" for="${fileInputId}" class="file-input-label" tabindex="0">
      <span style="padding-right: 1.6rem; padding-left: 0.4rem;" role="img" class="anticon">
        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 4.41009V15.0001H10V4.41009L13.29 7.71009L14.71 6.29009L9 0.590088L3.29 6.29009L4.71 7.71009L8 4.41009ZM0 18.0001V20.0001H18V18.0001H0Z" fill="black"></path></svg>
      </span>Datei auswählen...</label>
    <input id="${fileInputId}" ${isDisabled ? 'disabled' : ''} class="file-input impower-x-file-input" type="file" accept=".pdf,.doc,.xlsx,.jpg,.png" value="" multiple="multiple">
  `
}
const generateFileInput = (fileInputId = 'file-input', isDisabled = false, isButton = false) => {
  const newfileElement = document.createElement('div')
  newfileElement.classList.add('impower-x')
  if (isDisabled) {
    newfileElement.setAttribute('disabled', true)
  }
  newfileElement.innerHTML = isButton ? fileInputButtonHtml(fileInputId, isDisabled) : fileInputHtml(fileInputId, isDisabled)

  if (isButton) {
    const button = newfileElement.querySelector('.file-input-label')
    const input = newfileElement.querySelector(`#${fileInputId}`)
    if (button && input) {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        input.click()
      })
    }
  }
  return newfileElement
}
